import { loadPushNotificationService } from 'services/push-notifications/load'
import { resetData } from "services/redux/data/actions";
import { resetAuthentication } from "services/redux/authentication/actions";
import SecureStoreService from "services/store/secure-store";
import { resetCart } from "services/redux/cart/actions";
import { constantsActive } from 'utils/constants/constants'
import CacheStorage from 'utils/cache/CacheStorage'
import { appRestart } from 'utils/helper-restart'
import HelperFileCache from 'utils/HelperFileCache'
import { resetManagement } from 'services/redux/management/actions'

export default class UserService {
	
	static log = ( value ) => {
		console.prefix( 'UserService', value );
	}
	
	/**
	 * Logout function
	 * @param props
	 */
	static logout = async ( props = {} ) => {
		let timeout;
		let pushCleanupFinished = false;
		try {
			// Push cleanup is best effort and must not block leaving an account.
			await Promise.race([
				(async () => {
					const { default: notifications } = await loadPushNotificationService();
					if( !notifications.isAvailable() ) return;
					const { token } = await notifications.getToken();
					if( pushCleanupFinished ) return;
					await new Promise( resolve => {
						return (
							notifications.mutate( token, constantsActive.NO, {
								callbackSuccess: resolve,
								callbackError: resolve,
							} )
						);
					} );
				})(),
				new Promise( resolve => {
					timeout = setTimeout(resolve, 10000);
				} ),
			]);
		} catch {
			// Local cleanup is still required when push registration is unavailable.
		} finally {
			pushCleanupFinished = true;
			clearTimeout( timeout );
		}
		return this.callback( props );
	}

	/**
	 * Default callback
	 */
	static callback = async ( props = {} ) => {
		await SecureStoreService.deleteAll();
		for( const key of [ 'resetCart', 'resetAuthentication', 'resetData', 'resetManagement' ] ) {
			if( typeof props[ key ] === 'function' ) await props[ key ]();
		}
		await HelperFileCache.drop();
		await CacheStorage.clearCache({ restart: false });
		if( typeof props.callback === 'function' ) await props.callback();
		if( props.restart ?? true ) await appRestart();
	}

	/**
	 *
	 * @param dispatch
	 * @returns {{resetData: (function(): *), resetAuthentication: (function(): *), setLoggedIn: (function(*=): *)}}
	 */
	static mapDispatchToProps = ( dispatch ) => {
		return (
			{
				resetData: () => {
					return dispatch(resetData());
				},
				resetManagement: () => {
					return dispatch(resetManagement());
				},
				resetAuthentication: () => {
					return dispatch(resetAuthentication());
				},
				resetCart: () => {
					return dispatch(resetCart());
				},
			}
		);
	}
}
